module.exports = __webpack_public_path__ + "img/pic2.22cc7147.png";